export const COEFICIENTES_HEIDECKE: Record<string, number> = {
  'Nova(até 5 anos)': 0.0,
  'Nova|Regular': 0.0032,
  'Regular': 0.0252,
  'Regular|Reparos simples': 0.0809,
  'Reparos simples': 0.181,
  'Reparos simples|Reparos importantes': 0.332,
  'Reparos importantes': 0.526,
  'Reparos importantes|Sem valor': 0.752,
  'Sem valor': 1.0,
};

export const VIDA_UTIL_POR_PADRAO: Record<string, number> = {
  Alto: 80,
  Normal: 70,
  Baixo: 60,
  Mínimo: 50,
};

export const VIDA_UTIL_POR_TIPO: Record<string, number> = {
  Apartamento: 60,
  Casa: 70,
  Sobrado: 70,
  Kitnet: 60,
  Loft: 60,
  Cobertura: 60,
  Terreno: 0,
};
